import { Component } from "react";
import PropTypes from "prop-types";

import { showSuccessAlert, showErrorAlert, showInfoAlert } from "../../../helpers/alerts";

/**
 * Inline alert component used by forms to display error/success messages.
 * This is intentionally separated from the toast container so that importing
 * GlobalAlert does not pull react-toastify onto the critical path.
 */
class GlobalAlert extends Component {
  componentDidMount() {
    const { message, type, permanent, onClose } = this.props;

    const options = { onClose };
    if (permanent) options.autoClose = false;

    switch (type) {
      case "success":
        showSuccessAlert(message, options);
        break;

      case "error":
        showErrorAlert(message, options);
        break;

      default:
        showInfoAlert(message, options);
    }
  }

  render() {
    return null;
  }
}

GlobalAlert.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(["success", "warning", "error", "info"]),
  permanent: PropTypes.bool,
  onClose: PropTypes.func,
};

GlobalAlert.defaultProps = {
  message: "",
  type: "",
  permanent: false,
  onClose: () => {},
};

export default GlobalAlert;
